var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "offeringUpgrade" }, [
    _c("div", { staticClass: "introText" }, [
      _c("span", [
        _vm._v("\n\t\t\t" + _vm._s(_vm.$t("offeringUpgrade")) + "\n\t\t"),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "list" },
      _vm._l(_vm.options, function (option) {
        return _c(
          "li",
          {
            key: option.id,
            staticClass: "listItem",
            on: {
              click: function ($event) {
                return _vm.selectOption(option.id)
              },
            },
          },
          [
            _c("div", { staticClass: "textNode" }, [
              _c("div", { staticClass: "textWrapper" }, [
                _c("span", { staticClass: "itemHeader" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(option.offeringName) +
                      "\n\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(option.offeringSize) +
                      "\n\t\t\t\t\t"
                  ),
                ]),
              ]),
              _vm._v(" "),
              option.price
                ? _c("div", { staticClass: "priceWrapper" }, [
                    _c(
                      "span",
                      { staticClass: "priceValue" },
                      [
                        _c("PriceView", {
                          attrs: {
                            cents: option.price,
                            currency: _vm.currencyModel
                              ? _vm.currencyModel.id
                              : undefined,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "imageNode" },
              [
                _vm.productModel
                  ? _c("CoverView", {
                      attrs: {
                        "offering-id": option.id,
                        "show-place-holder": true,
                        "show-retry": true,
                        "product-model": _vm.productModel,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                option.featured
                  ? _c("div", { staticClass: "mostSelected" }, [
                      _c("span", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("topChoice")) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }